// export const API_URI = 'https://sukhvir0028.pythonanywhere.com'
export const API_URI = 'https://xn--nted-gra.com'
